import './helpers.js';
import { e as registerComponent, u as use } from './plugins-4daf8ef8.js';
import 'vue';
import './CheckRadioMixin-7636373e.js';
import { s as script } from './Checkbox-9a52ebcb.js';
export { s as OCheckbox } from './Checkbox-9a52ebcb.js';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, script);
  }

};
use(Plugin);

export default Plugin;
